export const environment: Environment = {
    production: true,
};
